import * as wbc from './wbc-export'
import {AjaxRequest} from "../lib/ajax"
import {CallJs} from "../lib/types"

export const wbcexport = wbc

export const runThemeEditPage: CallJs<{i?: number, page: string}> = (cb, params) => {
	const i = params.i || 1

	const btn = document.getElementById("applyEverywhere")

	//if we have nowhere to apply to, let's just wait a bit. "a bit" grows so that eventually we'll wait long enough no-one will know
	if(!btn) {
		if(i < 100000000)
			setTimeout(() => runThemeEditPage(cb, {...params, i: i + 1}), i*50)
		return
	}

	const ajax = new AjaxRequest(params.page)
	btn.onclick = () => confirm('Are you sure you want to apply this theme everywhere?') ? ajax.postForm({'apply this theme everywhere?': 'yes indeed'}) : void 0
}



// WEBPACK FOOTER //
// ./src/controlcentre/index.ts